// Hash determinístico — mesmo nome sempre mapeia para o mesmo token, sem
// índice de array nem aleatoriedade (mesma técnica de CertameAvatar, chave
// aqui é o nome do aluno em vez de id/sigla).
const AVATAR_ACCENT_TOKENS = ["blue", "purple", "green", "cyan"] as const;
type AvatarAccentToken = (typeof AVATAR_ACCENT_TOKENS)[number];

const AVATAR_ACCENT_CLASSES: Record<AvatarAccentToken, string> = {
  blue: "bg-accent-blue/[0.12] text-accent-blue-ink",
  purple: "bg-accent-purple/[0.12] text-accent-purple-ink",
  green: "bg-accent-green/[0.12] text-accent-green-ink",
  cyan: "bg-accent-cyan/[0.12] text-accent-cyan-ink",
};
// accent-orange fica fora de propósito — reservado a sinalizar pendência em
// outra tela, nunca aqui, para uma linha nunca ler como marcada por acaso.

function inscritoAvatarAccent(name: string): AvatarAccentToken {
  let sum = 0;
  for (let i = 0; i < name.length; i++) {
    sum += name.charCodeAt(i);
  }
  return AVATAR_ACCENT_TOKENS[sum % AVATAR_ACCENT_TOKENS.length];
}

function inscritoInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length < 2) return (words[0] ?? "").slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

export function InscritoAvatar({ name }: { name: string }) {
  const accent = inscritoAvatarAccent(name);
  return (
    <span
      aria-hidden
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[12px] font-semibold ${AVATAR_ACCENT_CLASSES[accent]}`}
    >
      {inscritoInitials(name)}
    </span>
  );
}
